import type { CodeState, FieldUsageTemplates } from './types'

const EMPTY_FIELD_USAGE: FieldUsageTemplates = { static: '', instance: '', global: '' }

export const selectSelectedSetupCommands = ({
  selectedTechnology = '',
  technologySetupCommands,
}: CodeState): Record<string, string> => technologySetupCommands[selectedTechnology] ?? {}

export const selectSelectedConfigurations = ({
  selectedTechnology = '',
  technologyConfigurations,
}: CodeState): Record<string, string> => technologyConfigurations[selectedTechnology] ?? {}

export const selectSelectedImportCode = ({ selectedTechnology = '', technologyImports }: CodeState): string =>
  technologyImports[selectedTechnology] ?? ''

export const selectSelectedInstanceCode = ({ selectedTechnology = '', technologyInstances }: CodeState): string =>
  technologyInstances[selectedTechnology] ?? ''

export const selectSelectedUsageCode = ({ selectedTechnology = '', technologyUsages }: CodeState): string =>
  technologyUsages[selectedTechnology] ?? ''

export const selectSelectedFieldUsageCode = ({
  selectedTechnology = '',
  technologyFieldUsages,
}: CodeState): FieldUsageTemplates => technologyFieldUsages[selectedTechnology] ?? EMPTY_FIELD_USAGE

export const selectSelectedVariableCode = ({ selectedTechnology = '', technologyVariables }: CodeState): string =>
  technologyVariables[selectedTechnology] ?? ''
